'use client';

import {
  STOREFRONT_PRICING_CHANNEL,
  type PricingContext,
} from '@template-project/storefront-bff-client';
import { useIntl } from '@/lib/intl';

export interface PricingContextValue {
  currency: string;
  country: string;
  /** Query-string shape for BFF GET routes */
  query: PricingContext & { currency: string; country: string };
}

/**
 * Locale-derived currency/country for tss-svc-pricing via the storefront BFF.
 */
export function usePricingContext(): PricingContextValue {
  const { countryConfig } = useIntl();
  const currency = countryConfig.currency.code;
  const country = countryConfig.countryCode;

  return {
    currency,
    country,
    query: { currency, country, channel: STOREFRONT_PRICING_CHANNEL },
  };
}
